import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { TaskDetailPage } from "./pages/TaskDetailPage";
import { TaskListPage } from "./pages/TaskListPage";

export function App() {
	return (
		<BrowserRouter>
			<div className="min-h-screen flex flex-col">
				<Header />
				<main className="flex-1">
					<Routes>
						<Route path="/" element={<Navigate to="/tasks" replace />} />
						<Route path="/tasks" element={<TaskListPage />} />
						<Route path="/tasks/:id" element={<TaskDetailPage />} />
					</Routes>
				</main>
			</div>
		</BrowserRouter>
	);
}
